import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "164",
  height: "292",
  fill: "none",
  viewBox: "0 0 164 292"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#shipment_protection_footer_orange_svg__a)\"><path fill=\"#F56A00\" d=\"m180.201 193.83 15.094 77.189-89.49-51.667z\"></path><rect width=\"130.17\" height=\"296.42\" x=\"88.751\" y=\"269.351\" stroke=\"#fff\" stroke-opacity=\".25\" rx=\"65.085\" transform=\"rotate(-135 88.751 269.351)\"></rect></g><defs><clipPath id=\"shipment_protection_footer_orange_svg__a\"><path fill=\"#fff\" d=\"M0 0h164v292H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }